import { Injectable } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';

@Injectable({
  providedIn: 'root'
})
export class AgGridLicenseService {
  private static licenseInitialized = false;

  constructor() {
    this.initializeLicense();
  }

  private initializeLicense(): void {
    if (!AgGridLicenseService.licenseInitialized) {
      // Set license key FIRST before any ag-Grid component loads
      LicenseManager.setLicenseKey(
        'Using_this_{AG_Grid}_Enterprise_key_{AG-095766}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Fedex}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Flare}_only_for_{10}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Flare}_need_to_be_licensed___{Flare}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_January_2027}____[v3]_[01]_MTgwMDU3NjAwMDAwMA==321a66cd86fb7f651aac403a67ce2d2d'
      );
      AgGridLicenseService.licenseInitialized = true;
      console.log('ag-Grid Enterprise license initialized');
    }
  }
}
